import store from '../redux/store';
import {
  ORGS_WITH_AUTOMATION_TAB_ACCESS,
  MARKETPLACE_UNIQUE_ORGS_ACCESS,
  ORGS_WITH_DYNAMIC_SPACE_ACCESS,
  ORGS_WITH_PRICING_NOTES_ACCESS,
} from './constants';

export const getUserOrg = () => {
  const { user } = store.getState();
  const organization = (user && user.organization && user.organization.id) || (user && user.organization_id) || 0;
  return parseInt(organization, 10);
};

export const getLogUserOrg = () => {
  const { user } = store.getState();
  const organization = (user && user.organization_id) || (user && user.organization && user.organization.id);
  return parseInt(organization, 10);
};

export const getDropdownUserOrg = () => {
  const { user } = store.getState();
  const organization = (user && user.organization && user.organization.id) || (user && user.organization_id);
  return parseInt(organization, 10);
};

export const getUserId = () => {
  const { user } = store.getState();
  const { email } = user;
  if (email.includes('+')) {
    const sub = email.split('+');
    return sub[0];
  }
  const sub = email.split('@');
  return sub[0];
};

export const getUserFromEmail = () => {
  const { user } = store.getState();
  const { email } = user;
  const plusPosition = email.indexOf('+');
  if (plusPosition >= 0) {
    return email.substring(0, plusPosition);
  }
  const emailPosition = email.indexOf('@');
  if (emailPosition >= 0) {
    return email.substring(0, emailPosition);
  }
  return email;
};

export const hasAutomationTabAccess = () => {
  const userOrgId = getUserOrg();
  return ORGS_WITH_AUTOMATION_TAB_ACCESS.includes(userOrgId);
};

export const hasDynamicSpaceoutAccess = () => {
  const userOrgId = getUserOrg();
  return ORGS_WITH_DYNAMIC_SPACE_ACCESS.includes(userOrgId);
};

export const hasMarketplaceUniquePriceAccess = () => {
  const userOrgId = getUserOrg();
  return MARKETPLACE_UNIQUE_ORGS_ACCESS.includes(userOrgId);
};

export const hasPricingNotesAccess = () => {
  const userOrgId = getUserOrg();
  return ORGS_WITH_PRICING_NOTES_ACCESS.includes(userOrgId);
};
